import { IParkingSubscriptionDTO, ParkingSubscriptionDTO } from './../../../../base/models/models.swagger.generated';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdministrationItemType, DetailsInitInfo, ItemEventInfo } from '../data-structures';
import { ConfigBasedStructuralEntryDTO, ParkingTariffDTO, ZoneDTO, ZoneDeviceDTO } from 'src/app/base/models/models.swagger.generated';
import { StructuralEntryDetailsComponent } from './structural-entry-details/structural-entry-details.component';
import { SubscriptionDetailsComponent } from './subscription-details/subscription-details.component';
import { TariffDetailsComponent } from './tariff-details/tariff-details.component';
import { ZoneDeviceDetailsComponent } from './zone-device-details/zone-device-details.component';
import { ZoneDetailsComponent } from './zone-details/zone-details.component';

@Component({
    selector: 'app-administration-details',
    templateUrl: './administration-details.component.html',
    styleUrls: ['./administration-details.component.scss'],
    imports: [ZoneDetailsComponent, ZoneDeviceDetailsComponent, TariffDetailsComponent, SubscriptionDetailsComponent, StructuralEntryDetailsComponent]
})
export class AdministrationDetailsComponent implements OnInit {
  @Input() public set selectedItem(value : DetailsInitInfo) {
    this._selectedItem = value;
  }

  public get selectedItem(): DetailsInitInfo {
    return this._selectedItem;
  }

  @Output() public cancel = new EventEmitter<void>();
  @Output() public itemCreated = new EventEmitter<ItemEventInfo>();
  @Output() public itemUpdated = new EventEmitter<ItemEventInfo>();
  @Output() public itemDeleted = new EventEmitter<ItemEventInfo>();
  @Output() public hasPendingDetailChangesChanged = new EventEmitter<boolean>();

  public AdministrationItemType = AdministrationItemType;

  public get showContent(): boolean {
    return this.selectedItem != null &&
          this.selectedItem.type != AdministrationItemType.ZoneCollection &&
          this.selectedItem.type != AdministrationItemType.ZoneDeviceCollection &&
          this.selectedItem.type != AdministrationItemType.ConfigBasedStructuralElementCollection &&
          this.selectedItem.type != AdministrationItemType.SubscriptionCollection;
  }

  private _selectedItem: DetailsInitInfo = null;

  constructor() { }

  ngOnInit() {
  }

  public onDetailCancel() {
    this.cancel?.emit();
  }

  public onTariffCreated(data: ParkingTariffDTO) {
    this.itemCreated.emit({ id: data.id, type: AdministrationItemType.Tariff, data, parentId: this.selectedItem.id });
  }

  public onTariffUpdated(data: ParkingTariffDTO) {
    this.itemUpdated.emit({ id: data.id, type: AdministrationItemType.Tariff, data, parentId: this.selectedItem.parentId });
  }

  public onTariffDeleted(id: number) {
    this.itemDeleted.emit({ id, type: AdministrationItemType.Tariff, data: null, parentId: this.selectedItem.parentId });
  }

  public onDeviceCreated(data: ZoneDeviceDTO) {
    this.itemCreated.emit({ id: data.id, type: AdministrationItemType.ZoneDevice, data, parentId: this.selectedItem.id });
  }

  public onDeviceUpdated(data: ZoneDeviceDTO) {
    this.itemUpdated.emit({ id: data.id, type: AdministrationItemType.ZoneDevice, data, parentId: this.selectedItem.parentId });
  }

  public onDeviceDeleted(id: number) {
    this.itemDeleted.emit({ id, type: AdministrationItemType.ZoneDevice, data: null, parentId: this.selectedItem.parentId });
  }

  public onZoneCreated(data: ZoneDTO) {
    this.itemCreated.emit({ id: data.id, type: AdministrationItemType.Zone, data: data, parentId: this.selectedItem.id});
  }

  public onZoneUpdated(data: ZoneDTO) {
    this.itemUpdated.emit({ id: data.id, type: AdministrationItemType.Zone, data, parentId: this.selectedItem.parentId });
  }

  public onZoneDeleted(id: number) {
    this.itemDeleted.emit({ id, type: AdministrationItemType.Zone, data: null, parentId: this.selectedItem.parentId });
  }

  public onSubscriptionCreated(data: IParkingSubscriptionDTO) {
    // TODO: fix typecasting
    this.itemCreated.emit({ id: data.id, type: AdministrationItemType.Subscription, data: data as ParkingSubscriptionDTO, parentId: this.selectedItem.id });
  }

  public onSubscriptionUpdated(data: IParkingSubscriptionDTO) {
    // TODO: fix typecasting
    this.itemUpdated.emit({ id: data.id, type: AdministrationItemType.Subscription, data: data as ParkingSubscriptionDTO, parentId: this.selectedItem.parentId });
  }

  public onSubscriptionDeleted(id: number) {
    this.itemDeleted.emit({ id, type: AdministrationItemType.Subscription, data: null, parentId: this.selectedItem.parentId });
  }

  public onStructuralEntryCreated(data: ConfigBasedStructuralEntryDTO) {
    this.itemCreated.emit({ id: data.id, type: AdministrationItemType.ConfigBasedStructuralElement, data, parentId: this.selectedItem.id });
  }

  public onStructuralEntryUpdated(data: ConfigBasedStructuralEntryDTO) {
    this.itemUpdated.emit({ id: data.id, type: AdministrationItemType.ConfigBasedStructuralElement, data, parentId: this.selectedItem.parentId });
  }

  public onStructuralEntryDeleted(id: number) {
    this.itemDeleted.emit({ id, type: AdministrationItemType.ConfigBasedStructuralElement, data: null, parentId: this.selectedItem.parentId });
  }

  public onHasPendingDetailChanges(hasChanges: boolean) {
    this.hasPendingDetailChangesChanged.emit(hasChanges);
  }
}
